import React from 'react';
import Header from './components/header';
import LoginForm from './components/login_form';
import { API_URL } from './config'

function LoginPage() {
    return (
        <> 
            <Header />
            <LoginForm />
        </>
    );
  }
  
  export default LoginPage; 